import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import ReactDOM from "react-dom/client";
import { HashRouter } from "react-router-dom";
import "@fontsource/barlow-condensed/latin-600.css";
import "@fontsource/barlow-condensed/latin-700.css";
import "@fontsource/ibm-plex-mono/latin-400.css";
import "@fontsource/ibm-plex-mono/latin-500.css";
import "@fontsource/ibm-plex-sans/latin-400.css";
import "@fontsource/ibm-plex-sans/latin-500.css";
import "@fontsource/ibm-plex-sans/latin-600.css";
import { App } from "./App";
import { captureBootstrapSecretFromCurrentUrl } from "./api/bootstrapSecret";
import { createForgeRemoteRuntime } from "./api/forgeRemoteApi";
import "./styles/tokens.css";
import "./styles/app.css";
import "./styles/responsive.css";

const freshActivationLink = captureBootstrapSecretFromCurrentUrl();
const runtime = createForgeRemoteRuntime({
  isDevelopment: import.meta.env.DEV,
  search: window.location.search,
  origin: window.location.origin,
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1 },
    mutations: { retry: false },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <App runtime={runtime} freshActivationLink={freshActivationLink} />
      </HashRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);

if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register(`${import.meta.env.BASE_URL}sw.js`).catch(() => {
      // The app remains usable online if registration is blocked by browser policy.
    });
  });
}
